<template>
    <div></div>
</template>
<script>
import { loginByAuthTicket } from '@/utils/examMiniApi.js'
import { setUserInfo, getUserInfo } from '@/utils/login.js'
import { urlQuery } from '@/utils/utils.js'

export default {
    created() {
        this.options = urlQuery()
        if (this.options.tpTicket) {
            loginByAuthTicket({ authTicket: this.options.tpTicket, appId: window.WX_APPID }).then((res) => {
                setUserInfo(res.data)
                this.$emit('success', res.data)
            })
        } else if (getUserInfo()) {
            this.$emit('success', getUserInfo())
        }
    },
}
</script>
